import React from 'react';

import { Link as LinkIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import { CompanyType } from 'src/api';
import { DetailPageLayout } from 'src/components/common';
import { EmployeeDataSearchScreen } from 'src/components/employee';
import {
  getPeoInviteLinkArgs,
  useCopyEmployeeInviteLink,
  useEmployeeDataSearch,
  useResendEmployeeInvite,
} from 'src/hooks/employee';
import { usePeoById, usePeoParamId } from 'src/hooks/peo';
import { useCurrentUserPermissions } from 'src/hooks/user';

export const PeoDetailEmployeesPage: React.FC = () => {
  const peoId = usePeoParamId();
  const { peo } = usePeoById(peoId);

  const { hasPlatformRoles } = useCurrentUserPermissions();

  const search = useEmployeeDataSearch({
    scope: hasPlatformRoles ? 'admin' : 'employerScope',
    skip: !peoId,
    companyFilter: peoId ? { companyType: CompanyType.Peo, companyId: peoId } : undefined,
  });

  const baseInviteLinkArgs = peo ? getPeoInviteLinkArgs(peo) : null;
  const inviteLinkArgs = baseInviteLinkArgs
    ? { ...baseInviteLinkArgs, entityDisplayName: peo?.displayName }
    : null;
  const copyInviteLink = useCopyEmployeeInviteLink(inviteLinkArgs);
  const resendInvite = useResendEmployeeInvite('cvStaff');

  return (
    <DetailPageLayout
      titleContent="Employees"
      topRightContent={
        <Button startIcon={<LinkIcon />} onClick={copyInviteLink}>
          Copy signup link
        </Button>
      }
    >
      <EmployeeDataSearchScreen
        {...search}
        allowEmailSearch
        enableAdminControls={hasPlatformRoles}
        inviteLinkArgs={inviteLinkArgs}
        inviteEmailOptionsScope={hasPlatformRoles ? 'admin' : 'employerScope'}
        sendInviteScope="cvStaff"
        onResendInvite={resendInvite}
      />
    </DetailPageLayout>
  );
};
